module.exports = __webpack_public_path__ + "img/360度，VR，AR，AI，只能科技，全息投影.e7528fbb.png";